import React, { CSSProperties } from 'react';
import * as Styled from './styled';
import SiteToolsDropdown from './SiteToolsDropdown/SiteToolsDropdown';
import AdviserInformation from '../../../../logic/domains/adviserInformation.domain';
import topMenuTestIds from '../TopMenu.elements';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconLookup } from '@fortawesome/fontawesome-common-types';
import SiteToolsTestIds from './SiteTools.elements';
import { getArrows } from '../../Common/Arrow/Arrow';

interface SiteToolsComponentProps {
	adviserInformation: AdviserInformation;
}

const userIconStyle: CSSProperties = {
	marginLeft: '5px',
	marginRight: '10px',
};

export const IGNORE_ON_CLICK_OUTSIDE_CLASS = 'site-tools-dropdown-menu';

const SiteTools: React.FunctionComponent<SiteToolsComponentProps> = (
	props: SiteToolsComponentProps
) => {
	const [isDropDownVisible, setDropDownVisibility] = React.useState(false);
	const siteToolsLinkRef: React.RefObject<any> = React.useRef();
	function toggleDropdown() {
		setDropDownVisibility(!isDropDownVisible);
	}

	const handleEscape = (event: any) => {
		if (
			(event.keyCode === 27 && isDropDownVisible) ||
			(event.shiftKey && event.keyCode === 9 && isDropDownVisible)
		) {
			toggleDropdown();
		}
	};

	return (
		<React.Fragment>
			<Styled.UserSiteTools
				aria-expanded={isDropDownVisible}
				ref={siteToolsLinkRef}
				onClick={toggleDropdown}
				onKeyUp={handleEscape}
				onKeyDown={handleEscape}
				className={IGNORE_ON_CLICK_OUTSIDE_CLASS}
				data-id={topMenuTestIds.userSiteToolsLink}
			>
				<FontAwesomeIcon style={userIconStyle} icon={faUser as IconLookup} />
				<Styled.AdvisorNameText>
					{props.adviserInformation.adviserName}
				</Styled.AdvisorNameText>
				{getArrows(isDropDownVisible)}
			</Styled.UserSiteTools>

			<div id={SiteToolsTestIds.siteToolsUserDetailsDropdownContainer}>
				{isDropDownVisible ? (
					<SiteToolsDropdown
						parentRef={siteToolsLinkRef}
						onClickOutside={toggleDropdown}
						outsideClickIgnoreClass={IGNORE_ON_CLICK_OUTSIDE_CLASS}
						adviserGroups={props.adviserInformation.adviserRoles}
					/>
				) : null}
			</div>
		</React.Fragment>
	);
};

export default SiteTools;
